<template>
	<div class="first_screen" id="home">
        <img class="video_poster" src="../assets/video/dolphin_summer_poster.webp" alt="dolphin summer">
		<video ref="video" @loadeddata="playVideo" class="first_screen_video"
			poster="../assets/video/dolphin_summer_poster.webp"
			playsinline
			autoplay
			muted
			loop
			preload="metadata"
		>
			<source src="../assets/video/dolphin_summer_opt.mp4#t=0.001" type="video/mp4">
			<source src="../assets/video/dolphin_summer_light.webm#t=0.001" type="video/webm">
		</video>
		<div class="bg_gradient"></div>
		<div class="first_screen__body">
			<div style="position:  relative; top: 0; left: 0; ">
				<h2 style="font-size: 0.9em;text-align: center;
					text-shadow: 0 0 20px black; padding-bottom: 0.3em;
				">
                    Загородный Комплекс
                    <br>
                    <span class="no-wrap">«Планета Дельфинов»</span>
				</h2>
                <h2 style="font-size: 0.8em;text-align: center;
					text-shadow: 0 0 20px black;
				">
					Dolphin Planet
				</h2>
				<div class="line_style" >
				</div>
                <h6 style="
					padding-top:  0.4em;
					font-size: 0.4em;
					font-family: 'Involve';
					letter-spacing: 0.5em !important;
					text-shadow: 0 0 20px black;

				">
					ОТЕЛЬ и СПА
				</h6>
				<div class="first_screen__action_button_box">
					<b-button id="first_screen__action_button" v-scroll-to="'#booking_box'" size="lg">ЗАБРОНИРОВАТЬ</b-button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>

export default {
	name: "FirstScreenComponent",
	components: {},
	methods: {
		playVideo() {
			if (this.$refs.video) {
				this.$refs.video.play().catch(() => {});
			}
		}
	},
}
</script>

<style>
	h6, h2 {
		margin-bottom:  0 !important;
	}

    .video_poster {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        height: 100%;
        width: auto;
    }
	.first_screen_video {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		object-fit: cover;
		z-index: 0;
	}
	.bg_gradient  {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		height: 50%;
		background: linear-gradient(360deg, #F7F3ED 3.59%, rgba(247, 243, 237, 0.8) 45.77%, rgba(247, 243, 237, 0) 96.3%);
		z-index: 1;
	}
	.first_screen {
		background-color: #F7F3ED;
		min-height: 100vh;
		width: 100%;
		position: relative;
		overflow: hidden;
	}

	#first_screen__action_button {
		margin-top: 2em;
		padding: 1em 2em !important;
		background-color: #A39171;
		border-radius: 8px;
		color: #F7F3ED;
		letter-spacing: 0.15em;
		border: 1px solid #A39171;
		transition: all 0.3s ease;
	}

	#first_screen__action_button:hover {
		background-color: #8B7355;
		border-color: #8B7355;
		color: #F7F3ED;
		transform: scale(1.05);
		box-shadow: 0 4px 15px rgba(163, 145, 113, 0.4);
	}

	.first_screen__body {
		position: relative;
		display: flex;
		min-height: 100vh;
		width: 100%;
		justify-content: center;
		align-content: center;
		align-items: center;
		flex-direction: column;
		flex-wrap: nowrap;
		font-family: 'Involve';
		font-style: normal;
		font-weight: 400;
		font-size: 60px;
		text-align: center;
		color: #FFFFFF;
		text-shadow: color(srgb 0.275 0.2458 0.1939) 1px 1px 4px;
		z-index: 2;
	}
	.line_style {
		height: 1px;
		border-bottom: 1px solid #A39171;
		width: 100%;
	}


	@media (max-width: 575px) {
		.first_screen {
			height: 100vh;
			width: 100%;
		}
		.first_screen__body {
			height: 100%;
			display: flex;
			justify-content: flex-end;
			flex-direction: column;
			flex-wrap: nowrap;
			padding-bottom: 0.5em;
		}
		.line_style {
			height: 1px;
			border-bottom: 1px solid #A39171;
			width: 80%;
			margin: 0 auto;
		}
		.first_screen__action_button_box {
			padding-top: 2em;
		}
		#first_screen__action_button {
			margin-top: 2em;
			padding: 1em 2em !important;
			background-color: transparent;
			border: 1px solid #A39171;
			border-radius: 8px;
			color: #333333;
			letter-spacing: 0.2em;
			transition: all 0.3s ease;
		}

		#first_screen__action_button:hover {
			background-color: #8B7355;
			border-color: #8B7355;
			color: #F7F3ED;
			transform: scale(1.05);
			box-shadow: 0 4px 15px rgba(163, 145, 113, 0.4);
		}
	}

</style>